export default () => {};


// WEBPACK FOOTER //
// ./plugins/app/site/pagesections/header/index.js